import React, { useEffect, useState } from "react";
import {
    Container,
    Card,
    GoBack,
    Col,
    Row,
    PagerItem,
    PagerLink,
    Pager,
    Icon,
    Label,
    Button,
    CardBody, CardTitle, CardText,
    Spinner, Alert
} from "design-react-kit";
import { useNavigate, useLocation } from "react-router-dom";
import { properties } from "../../../config/properties";
import SpinnerCustom from "../../layout/Spinner";


const styles = {

    layoutRow: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '2.5rem',
        marginBottom: '2.5rem',
    },
    colLeft: {
        flex: '1 1 45%',
        minWidth: '320px',
    },
    colRight: {
        flex: '1 1 45%',
        minWidth: '320px',
    },
    fullWidth: {
        width: '100%',
    },
    titleIcon: {
        marginRight: '0.75rem',
    },
    card: {
        padding: '2rem',
        borderRadius: '12px',
        backgroundColor: '#fefefe',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
        //boxShadow: '0 6px 18px rgba(0, 0, 0, 0.06)',
        //border: 'none',
        border: '1px solid #ddd',
        transition: 'transform 0.2s ease-in-out',
    },
    cardTitle: {
        padding: '2rem',
        borderRadius: 'none',
        backgroundColor: '#fefefe',
        boxShadow: '0 8px 24px #fefefe',
        //boxShadow: '0 6px 18px rgba(0, 0, 0, 0.06)',
        //border: 'none',
        //border: '1px solid #ddd',
        transition: 'transform 0.2s ease-in-out',
    },
    cardTitle1: {
        padding: '2rem',
        borderRadius: '12px',
        backgroundColor: '#fefefe', // Fondamentale che abbia un colore di sfondo solido
        transition: 'transform 0.2s ease-in-out',

        // --- Aggiunte Chiave ---
        //position: 'sticky', // Attiva il contesto di sovrapposizione
        zIndex: 2,            // Mette il titolo su un livello superiore
    },

    card1: {
        padding: '2rem',
        borderRadius: '12px',
        backgroundColor: '#fefefe',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
        border: '1px solid #ddd',
        transition: 'transform 0.2s ease-in-out',
        // Non è necessario specificare lo z-index qui, ma se lo facessi,
        // assicurati che sia inferiore a quello del titolo (es. zIndex: 1)
    },
    sectionTitle: {
        fontSize: '1.1rem',
        fontWeight: '700',
        color: '#0b5ed7',
        borderBottom: '2px solid #0b5ed7',
        paddingBottom: '0.25rem',
        marginBottom: '1rem',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
    },
    fieldLabel: {
        fontWeight: '500',
        color: '#6c757d',
        marginBottom: '0.25rem',
        fontSize: '0.9rem',
    },
    fieldValue: {
        marginBottom: '1rem',
        fontWeight: '600',
        fontSize: '1rem',
        color: '#212529',
    },
    firmaImage: {
/*
        maxWidth: '100%',
        width: 'auto',
        maxHeight: '200px',


 */
        maxWidth: '100%',
        width: 'auto',
        height: '150px',
        minHeight: '150px',
        maxHeight: '150px',
        objectFit: 'contain',
        border: '1px solid #dee2e6',
        borderRadius: '6px',
        backgroundColor: '#f8f9fa',
        padding: '0.5rem',
        display: 'block',

    },
    firmaPlaceholder: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '120px',
        backgroundColor: '#f8f9fa',
        border: '1px dashed #ced4da',
        borderRadius: '6px',
        color: '#6c757d',
        fontStyle: 'italic',
        fontSize: '0.9rem',
    },
    tableRowText: {
        padding: '2rem',
        color: '#6c757d',
        fontSize: '1rem',
    },
};



const ListaSpecimen = ({user}) => {

    const location = useLocation();
    const { ricerca } = location.state || {};

    const initialLimit = ricerca?.limit ?? 10;
    const initialOffset = ricerca?.offset ?? 0;

    const [limit, setLimit] = useState(initialLimit);
    const [offset, setOffset] = useState(initialOffset);

    const [datiRicerca, setDatiRicerca] = useState(ricerca?.dati || {});
    const [persone, setPersone] = useState([]);
    const [loadingUser, setLoadingUser] = useState(true);

    const navigate = useNavigate();

    const [totalElements, setTotalElements] = useState(0);

    const [isDownloading, setIsDownloading] = useState(false);

    const [alert, setAlert] = useState({visible: false, type: '', message: ''});

    const delayRefresh = 10;

    const totalPages = Math.ceil(totalElements / limit);
    const currentPage = Math.floor(offset / limit) + 1;

    const handleListaSpecimenClick = () => {
        // Aggiorna questo percorso se è diverso
        navigate('/private/ricercaListaSpecimen');
    };

    useEffect(() => {
        if (datiRicerca) {
            getSpecimenList({
                userID: user.userID,
                cciaa: user.cciaa,
                gruppoUtente:user.gruppoUtente,
                offset,
                limit,
                dati: datiRicerca
            });
        }
    }, [offset, limit, datiRicerca]);

    const getSpecimenList = async (params) => {
        try {
            setLoadingUser(true);

            const res = await fetch(
                properties.fullBaseUrl + properties.baseAppUrl + "/std/service/listaSpecimen",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(params),
                }
            );

            if(res.status === 401){

                const datasResponse = await res.json();

                setPersone([]);
                setTotalElements(0);

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return;

            }


            if (!res.ok) throw new Error("Errore HTTP");

            const data = await res.json();

            setTotalElements(data.totalElements || 0);
            setPersone(data.dati || []);

        } catch (e) {

            setPersone([]);
            setTotalElements(0);
            setAlert({visible: true, type: 'danger', message: 'Errore di rete o server non raggiungibile.'});
            window.scrollTo({top: 0, behavior: 'smooth'});

        }finally {
            setLoadingUser(false);
        }
    };

    const areeMap = new Map();

    persone.forEach(persona => {
        const idArea = persona.fkIdAreaCompetenza;

        if (!areeMap.has(idArea)) {
            areeMap.set(idArea, {
                descrizione: persona.areaDescrizione,
                persone: [],
            });
        }

        areeMap.get(idArea).persone.push(persona);
    });

    const handleLimitChange = (newLimit) => {
        setLimit((prev) => {
            // React garantirà che il nuovo limit venga impostato prima del useEffect
            return newLimit;
        });
        setOffset(0); // questo causerà il useEffect a triggerarsi con offset 0 e nuovo limit
    };

    const handlePageChange = (page) => {
        const newOffset = (page - 1) * limit;
        setOffset(newOffset);
    };

    function FirmaComponent({ base64String, label }) {
        if (!base64String) {
            return (
                <div style={styles.firmaPlaceholder}>
                    <span>Nessuna {label}</span>
                </div>
            );
        }
        const imgSrc = base64String.startsWith('data:image') ? base64String : `data:image/png;base64,${base64String}`;

        return (
            <img
                src={imgSrc}
                alt={label}
                style={styles.firmaImage}
            />
        );
    }

    const handleDownload = async () => {

        try {

            setIsDownloading(true);

            const param = {

                offset: 0,
                limit : -1,
                dati: datiRicerca,
                userID: user.userID,
                cciaa: user.cciaa,
                gruppoUtente:user.gruppoUtente
            }

            const response = await fetch(properties.fullBaseUrl + properties.baseAppUrl + "/std/service/getPdfListaSpecimen", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(param),
            });

            if(response.status === 401){

                const datasResponse = await response.json();

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return;

            }

            if (!response.ok) {
                throw new Error("Errore nel download del PDF");
            }

            const blob = await response.blob();
            const fileName = "Organigramma_" + datiRicerca.cciaa + ".pdf";

            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName; // qui imposti il nome
            document.body.appendChild(link);
            link.click();
            link.remove();



        } catch (error) {
            setAlert({visible: true, type: 'danger', message: 'Errore di rete o server non raggiungibile.'});
        }finally {
            setIsDownloading(false);
        }
    };

    if (loadingUser) {

        return (

            <Container fluid className="vh-100 d-flex justify-content-center align-items-center bg-light">

                <p className="mb-3">
                    <strong>
                        Caricamento
                    </strong>
                </p>
                <SpinnerCustom active/>


            </Container>
        );
    }

    const renderPagination = () => {
        const pages = [];

        let startInd =  (currentPage-1) > 0 ? currentPage-1 : 1
        let endInd =  (currentPage+1) < totalPages ? currentPage+1 : totalPages


        if(currentPage > 2){
            pages.push(
                <PagerItem
                    key={1}
                    active={1 === currentPage}
                    className={1 === currentPage ? "active-pager-item" : ""}
                >
                    <PagerLink
                        href="#"
                        aria-current={1 === currentPage ? "page" : undefined}
                        onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(1);
                        }}
                    >
                        {1}
                    </PagerLink>
                </PagerItem>
            );
            pages.push(
                <PagerItem
                    key={"-"}

                >
                    <PagerLink
                    >
                        -
                    </PagerLink>
                </PagerItem>
            );
        }

        for (let i =  startInd  ; i <= endInd  ; i++) {


            pages.push(
                <PagerItem
                    key={i}
                    active={i === currentPage}
                    className={i === currentPage ? "active-pager-item" : ""}
                >
                    <PagerLink
                        href="#"
                        aria-current={i === currentPage ? "page" : undefined}
                        onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(i);
                        }}
                    >
                        {i}
                    </PagerLink>
                </PagerItem>
            );


        }

        if(currentPage < totalPages-2){

            pages.push(
                <PagerItem
                    key={"-"}

                >
                    <PagerLink
                    >
                        -
                    </PagerLink>
                </PagerItem>
            );

            pages.push(
                <PagerItem
                    key={totalPages}
                    active={totalPages === currentPage}
                    className={totalPages === currentPage ? "active-pager-item" : ""}
                >
                    <PagerLink
                        href="#"
                        aria-current={totalPages === currentPage ? "page" : undefined}
                        onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(totalPages);
                        }}
                    >
                        {totalPages}
                    </PagerLink>
                </PagerItem>
            );
        }
        return (
            <Pager className="mt-3 justify-content-center" aria-label="Navigazione elenco persone">
                <PagerItem disabled={currentPage === 1}>
                    <PagerLink
                        previous
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(currentPage - 1);
                        }}
                    >
                        <Icon icon="it-chevron-left" />
                    </PagerLink>
                </PagerItem>

                {pages}

                <PagerItem disabled={currentPage === totalPages}>
                    <PagerLink
                        next
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(currentPage + 1);
                        }}
                    >
                        <Icon icon="it-chevron-right" />
                    </PagerLink>
                </PagerItem>
            </Pager>
        );
    };


    return(

        <Container className="bg-white py-3 py-lg-6">

            <h2 className={"mt-5"}>Lista Specimen</h2>
            <h3 className="mb-5 mt-5" style={{color: "#45466E"}}>Camera di commercio di {datiRicerca.cciaa === 'ST' ? "InfoCamere" : datiRicerca.cciaa}</h3>

            {alert.visible && (
                <Alert color={alert.type} isOpen={alert.visible} toggle={() => setAlert({...alert, visible: false})}>
                    {alert.message}
                </Alert>
            )}

            {persone.length > 0 ?

                <Row className="mb-3 ">

                    <Col md={4}>
                        <Label htmlFor="limit-select" className="mb-0"><strong>Righe per pagina:</strong>

                            <select
                                id="limit-select"
                                value={limit}
                                onChange={(e) => handleLimitChange(Number(e.target.value))}
                                className="form-select m-3"
                            >
                                <option value={5}>5</option>
                                <option value={10}>10</option>
                                <option value={20}>20</option>
                                <option value={50}>50</option>
                            </select>
                        </Label>

                    </Col>
                    <Col md={8} className={"mt-4 text-end"}>
                        <Button
                            className="mb-3 btn btn-outline-primary"
                            type="click"
                            onClick={handleDownload}
                            disabled={isDownloading}
                        >
                            {isDownloading ? <Spinner active small/> : "Download Pdf"}
                        </Button>

                    </Col>

                </Row>

                :
                null
            }

            {persone.length > 0 && (
                <>
                    <Row className="mt-2">
                        <Col className="text-end">
                            <small className="text-muted">
                                Visualizzati
                                da <strong>{offset + 1}</strong> a <strong>{Math.min(offset + limit, totalElements)}</strong> di <strong>{totalElements}</strong> risultati
                            </small>
                        </Col>
                    </Row>
                    {totalPages > 1 && renderPagination()}
                </>
            )}

            <Container className="bg-white py-3 py-lg-6">

                {persone.length > 0 ? (
                    Array.from(areeMap.entries()).map(([idArea, gruppo]) => (
                        <div key={idArea}>
                            {/* Header sticky una volta per area */}
                            <div className="sticky-md-top" style={styles.cardTitle}>
                                <h3
                                    style={{
                                        ...styles.sectionTitle,
                                        fontSize: "xxx-large",
                                        borderBottom: "none",
                                    }}
                                >
                                    {gruppo.descrizione}
                                </h3>
                            </div>

                            {/* Mappa delle persone per questa area */}
                            {gruppo.persone.map((persona, index) => (
                                <div key={index} style={styles.layoutRow}>
                                    <div style={styles.colLeft}>
                                        <Card style={styles.card}>
                                            <div>
                                                <p style={{...styles.fieldValue, fontSize: "x-large"}}>
                                                    {persona.nome} {persona.cognome}
                                                </p>
                                                <p style={{...styles.fieldValue, fontSize: "large"}}>
                                                    {persona.ruoloTitolo}
                                                </p>
                                            </div>

                                            <div style={styles.fullWidth}>
                                                <Card style={{...styles.card, boxShadow: "none", border: "none"}}>
                                                    <h2 style={{...styles.sectionTitle}}>
                                                        <Icon icon="it-pencil" size="sm" style={styles.titleIcon}/>
                                                        Firma
                                                    </h2>

                                                    <Container>
                                                        <Row className={"mb-4"}>
                                                            <Col className={"col-md-9"}>
                                                                <p style={{...styles.fieldValue, fontSize: "large"}}>
                                                                    Firma per esteso
                                                                </p>
                                                                <FirmaComponent base64String={persona.firma.firma}/>
                                                            </Col>

                                                            <Col className={"col-md-3"}>
                                                                <p style={{...styles.fieldValue, fontSize: "large"}}>
                                                                    Firma abbreviata
                                                                </p>
                                                                <div
                                                                    style={{display: "flex", justifyContent: "center"}}>
                                                                    <FirmaComponent
                                                                        base64String={persona.firma.siglaFirma}/>
                                                                </div>

                                                            </Col>
                                                        </Row>

                                                        <Row>
                                                            <Col>
                                                                <p style={{...styles.fieldValue, fontSize: "large"}}>
                                                                Firma depositata
                                                                    il: {persona.firma.dataFirma || "-"}
                                                                </p>
                                                            </Col>
                                                            <Col>
                                                                <p style={{color: "green"}}>
                                                                    {persona.firma.stato || "-"}
                                                                </p>
                                                            </Col>
                                                        </Row>
                                                    </Container>

                                                    <h2 style={styles.sectionTitle}>
                                                        <Icon icon="it-key" size="sm" style={styles.titleIcon}/>
                                                        Deleghe
                                                    </h2>

                                                    <Container>
                                                        {Array.isArray(persona.deleghe) && persona.deleghe.length > 0 ? (
                                                            persona.deleghe.map((delega, index) => (
                                                                <div key={index} style={{marginBottom: "1rem"}}>
                                                                    <p style={styles.fieldLabel}>Descrizione</p>
                                                                    <p style={{
                                                                        ...styles.fieldValue,
                                                                        fontSize: "x-large"
                                                                    }}>
                                                                        {delega.descrizione || "-"}
                                                                    </p>

                                                                    <Row>
                                                                        <Col>
                                                                            <p style={styles.fieldValue}>
                                                                                Valida dal: {delega.dataInizio || "-"}
                                                                            </p>
                                                                        </Col>

                                                                        {delega.stato === "SCADUTA" && (
                                                                            <Col>
                                                                                <p style={styles.fieldValue}>
                                                                                    fino al: {delega.dataFine || "-"}
                                                                                </p>
                                                                            </Col>
                                                                        )}

                                                                        <Col>
                                                                            <p
                                                                                style={{
                                                                                    color: delega.stato === "SCADUTA" ? "red" : "green",
                                                                                }}
                                                                            >
                                                                                {delega.stato || "-"}
                                                                            </p>
                                                                        </Col>
                                                                    </Row>
                                                                    <hr
                                                                        style={{
                                                                            marginTop: "1rem",
                                                                            borderTop: "2px solid #ccc",
                                                                        }}
                                                                    />
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <p>Nessuna delega disponibile.</p>
                                                        )}
                                                    </Container>
                                                </Card>
                                            </div>
                                        </Card>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ))
                ) : (
                    <Container>


                        <div className="guidance-box lead py-lg-5 py-lg-6 mb-5">
                            <p style={{textAlign: "center"}}>
                                Attualmente la seguente camera di commercio non presenta aluno Specimen
                                Pubblicato.
                            </p>
                        </div>

                    </Container>
                )}


            </Container>

            {persone.length > 0 && (
                <>
                    <Row className="mt-2">
                        <Col className="text-end">
                            <small className="text-muted">
                                Visualizzati
                                da <strong>{offset + 1}</strong> a <strong>{Math.min(offset + limit, totalElements)}</strong> di <strong>{totalElements}</strong> risultati
                            </small>
                        </Col>
                    </Row>
                    {totalPages > 1 && renderPagination()}
                </>
            )}


        </Container>
    );


}
export default ListaSpecimen;